import { render, staticRenderFns } from "./PaymentErrorAlertMessage.vue?vue&type=template&id=4368cc4c&scoped=true"
import script from "./PaymentErrorAlertMessage.vue?vue&type=script&lang=js"
export * from "./PaymentErrorAlertMessage.vue?vue&type=script&lang=js"
import style0 from "./PaymentErrorAlertMessage.vue?vue&type=style&index=0&id=4368cc4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4368cc4c",
  null
  
)

export default component.exports